export default "__VITE_ASSET__DM3mJ4oo__"